import permissions from './permissions_list'

// Define system roles
export const ROLES = Object.freeze({
    ADMINS: "Super Admins",
    TEACHERS: "Teachers",
});

export const PERMISSIONS = Object.freeze(permissions);
